export const conversationsService = {
  local: 'http://localhost:3000',
  qa: 'https://conversations-tbitio.koyeb.app',
  pdn: 'https://conversations.t-bit.io',
};

export const testPhoneNumbers = {
  qa: '573133321652',
  pdn: '573054208203',
};

export const formatPhoneNumber = (phoneNumber: string | undefined | null) => {
  if (!phoneNumber) return '';
  phoneNumber = phoneNumber.replace(/\D/g, '');
  return phoneNumber.replace(
    /(\d{1,2})(\d{3})(\d{4})(\d{3})/,
    '+$1 ($2) $3 $4',
  );
};

export const environment = import.meta.env
  .VITE_ENVIRONMENT as keyof typeof conversationsService;
